import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionN } from '../../oasis-sections/section-n';
import { OASIS } from '../../oasis-types';
import { isActive, isTimepoint } from '../util';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionNConsistency = ({ input, ctx, version, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        const payload = input;
        // N-consistency-4480 If M0100_ASSMT_REASON=[09] then M2020_CRNT_MGMT_ORAL_MDCTN cannot equal [^].
        if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) && !payload.SectionN?.m2020) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: '-4361  M2020 cannot be empty',
                path: ['SectionN', 'm2020'],
            });
        }
        if (isActive(SectionN.n0415, version, payload.SectionA?.m0100) &&
            isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload.SectionA?.m0100)) {
            const payload = input.SectionN?.n0415;
            if (payload) {
                // N-none of above-6020 (a) If N0415Z1=[1], then the following items must equal [0]: N0415A1, N0415E1, N0415F1, N0415H1, N0415I1, N0415J1.
                if (payload.n0415z1 &&
                    [payload.n0415a1, payload.n0415e1, payload.n0415f1, payload.n0415h1, payload.n0415i1, payload.n0415j1].some((item) => item)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-6020 (a) If N0415Z1 is checked, then items from N0415A1 through N0415J1 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // N-none of above-6020 (b) If N0415Z1=[0], then at least one of the following items must equal [1]: N0415A1, N0415E1, N0415F1, N0415H1, N0415I1, N0415J1.
                if (!payload.n0415z1 &&
                    [payload.n0415a1, payload.n0415e1, payload.n0415f1, payload.n0415h1, payload.n0415i1, payload.n0415j1].every((item) => !item)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-6020 (b) If N0415Z1 is NOT checked, then at least one item from N0415A1 through N0415J1 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // N-none of above-6020 (c) If N0415Z1=[-], then at least one of the following active items must equal [-], and the rest of the active items must be [0,-]: N0415A1, N0415E1, N0415F1, N0415H1, N0415I1, N0415J1.
                // -5960 (a) If N0415A1=[0], then N0415A2 must equal [^].
                if (!payload.n0415a1 && payload.n0415a2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5960 (a) If N0415A1 is NOT checked, then N0415A2 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5960 (b) If N0415A1=[1], then N0415A2 must not equal [^].
                if (payload.n0415a1 && !payload.n0415a2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5960 (b) If N0415A1 is checked, then N0415A2 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5970 (a) If N0415E1=[0], then N0415E2 must equal [^].
                if (!payload.n0415e1 && payload.n0415e2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5970 (a) If N0415E1 is NOT checked, then N0415E2 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5970 (b) If N0415E1=[1], then N0415E2 must not equal [^].
                if (payload.n0415e1 && !payload.n0415e2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5970 (b) If N0415E1 is checked, then N0415E2 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5980 (a) If N0415F1=[0], then N0415F2 must equal [^].
                if (!payload.n0415f1 && payload.n0415f2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5980 (a) If N0415F1 is NOT checked, then N0415F2 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5980 (b) If N0415F1=[1], then N0415F2 must not equal [^].
                if (payload.n0415f1 && !payload.n0415f2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5980 (b) If N0415F1 is checked, then N0415F2 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5990 (a) If N0415H1=[0], then N0415H2 must equal [^].
                if (!payload.n0415h1 && payload.n0415h2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5990 (a) If N0415H1 is NOT checked, then N0415H2 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -5990 (b) If N0415H1=[1], then N0415H2 must not equal [^].
                if (payload.n0415h1 && !payload.n0415h2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-5990 (b) If N0415H1 is checked, then N0415H2 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -6000 (a) If N0415I1=[0], then N0415I2 must equal [^].
                if (!payload.n0415i1 && payload.n0415i2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-6000 (a) If N0415I1 is NOT checked, then N0415I2 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -6000 (b) If N0415I1=[1], then N0415I2 must not equal [^].
                if (payload.n0415i1 && !payload.n0415i2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-6000 (b) If N0415I1 is checked, then N0415I2 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -6010 (a) If N0415J1=[0], then N0415J2 must equal [^].
                if (!payload.n0415j1 && payload.n0415j2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-6010 (a) If N0415J1 is NOT checked, then N0415J2 must NOT be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
                // -6010 (b) If N0415J1=[1], then N0415J2 must not equal [^].
                if (payload.n0415j1 && !payload.n0415j2) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: `-6010 (b) If N0415J1 is checked, then N0415J2 must be checked.`,
                        path: ['SectionN', 'n0415'],
                    });
                }
            }
        }
    }
    else if (!field) {
        // section level
        const payload = input;
        // N-consistency-5470 If M2001_DRUG_RGMN_RVW=[-], then M2003_MDCTN_FLWP must equal [-].
        if (payload?.m2001 === '-' && payload.m2003 !== '-') {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5470  If M2001 is 'No Information Available', them M2003 must be 'No Information Available'`,
                path: ['m2003'],
            });
        }
    }
    else {
        // field level
    }
};
// N-consistency-4480 If M0100_ASSMT_REASON=[09] then M2020_CRNT_MGMT_ORAL_MDCTN cannot equal [^].
// N-consistency-5470 If M2001_DRUG_RGMN_RVW=[-], then M2003_MDCTN_FLWP must equal [-].
// N-none of above-6020
// (a) If N0415Z1=[1], then the following items must equal [0]: N0415A1, N0415E1, N0415F1, N0415H1, N0415I1, N0415J1.
// (b) If N0415Z1=[0], then at least one of the following items must equal [1]: N0415A1, N0415E1, N0415F1, N0415H1, N0415I1, N0415J1.
// (c) If N0415Z1=[-], then at least one of the following active items must equal [-], and the rest of the active items must be [0,-]: N0415A1, N0415E1, N0415F1, N0415H1, N0415I1, N0415J1.
